
export default function StepSection() {
  const steps = [
    {
      number: 1,
      title: '公式サイトから申し込み',
      time: '約5分',
      description: 'DMM FX公式サイトにアクセスし、「口座開設」ボタンをクリック。メールアドレスの登録から基本情報の入力まで、画面の案内に沿って進めるだけです。',
      image: 'https://public.readdy.ai/ai/img_res/076d9e35eccd179d74dddbf09e20104c.jpg',
      details: [
        { icon: 'ri-mail-line', text: 'メールアドレスを入力して仮登録' },
        { icon: 'ri-user-line', text: '氏名・住所・電話番号などの基本情報を入力' },
        { icon: 'ri-briefcase-line', text: '職業・年収・投資経験などを選択' },
        { icon: 'ri-checkbox-circle-line', text: '各種規約に同意して申し込み完了' },
      ],
      tips: '入力項目は選択式が多く、手入力は最小限。迷うことなく進められます。',
    },
    {
      number: 2,
      title: '本人確認書類の提出',
      time: '約3分',
      description: 'スマホのカメラで本人確認書類と自分の顔を撮影するだけ。「スマホでスピード本人確認」を選べば、最短即日で審査が完了します。',
      image: 'https://readdy.ai/api/search-image?query=person%20holding%20smartphone%20taking%20photo%20of%20identification%20card%20for%20digital%20verification%20process%20clean%20minimal%20background%20with%20soft%20teal%20green%20accent%20modern%20fintech%20identity%20verification%20flat%20illustration%20style&width=600&height=400&seq=ao-step2-v2&orientation=landscape',
      details: [
        { icon: 'ri-bank-card-line', text: '運転免許証またはマイナンバーカードを撮影' },
        { icon: 'ri-camera-line', text: '顔写真をスマホで撮影（セルフィー）' },
        { icon: 'ri-upload-cloud-line', text: '撮影した画像を自動アップロード' },
        { icon: 'ri-shield-check-line', text: 'AI認証で即時照合・審査開始' },
      ],
      tips: 'マイナンバーカードなら本人確認とマイナンバー提出が1枚で完了！最もおすすめです。',
    },
    {
      number: 3,
      title: '審査完了・口座開設',
      time: '最短即日',
      description: '審査が完了すると、登録メールアドレスにログイン情報が届きます。スマホでスピード本人確認を利用した場合、最短で当日中に口座開設が完了します。',
      image: 'https://readdy.ai/api/search-image?query=email%20notification%20on%20smartphone%20screen%20showing%20account%20approved%20success%20message%20with%20green%20checkmark%20icon%20clean%20minimal%20white%20background%20modern%20fintech%20app%20notification%20flat%20illustration%20style&width=600&height=400&seq=ao-step3-v2&orientation=landscape',
      details: [
        { icon: 'ri-mail-check-line', text: '審査完了メールを受信' },
        { icon: 'ri-key-line', text: 'ログインIDとパスワードを確認' },
        { icon: 'ri-login-box-line', text: 'マイページにログイン' },
        { icon: 'ri-settings-3-line', text: '初期設定を完了' },
      ],
      tips: '郵送での本人確認を選んだ場合は、簡易書留の受け取りが必要です（2〜3営業日）。',
    },
    {
      number: 4,
      title: '入金して取引開始！',
      time: '約2分',
      description: 'クイック入金なら手数料無料で即時反映。最低入金額の制限もないので、少額からスタートできます。入金が完了したら、いよいよFX取引の開始です！',
      image: 'https://readdy.ai/api/search-image?query=smartphone%20showing%20mobile%20banking%20deposit%20screen%20with%20successful%20transfer%20confirmation%20and%20trading%20chart%20in%20background%20clean%20minimal%20white%20background%20modern%20fintech%20app%20interface%20flat%20illustration%20style&width=600&height=400&seq=ao-step4-v2&orientation=landscape',
      details: [
        { icon: 'ri-bank-line', text: 'クイック入金で即時反映（手数料無料）' },
        { icon: 'ri-funds-line', text: '約340の金融機関に対応' },
        { icon: 'ri-line-chart-line', text: '取引ツールで通貨ペアを選択' },
        { icon: 'ri-rocket-line', text: 'いよいよFX取引スタート！' },
      ],
      tips: '初心者は5万円〜10万円程度の少額入金から始めるのがおすすめです。',
    },
  ];

  return (
    <section className="py-10 md:py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-4">口座開設の流れ【全4ステップ】</h2>
          <p className="text-xs md:text-base text-gray-600">画面イメージとともに、各ステップを詳しく解説します</p>
        </div>

        <div className="space-y-8 md:space-y-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute left-1/2 -bottom-16 w-px h-16 bg-gradient-to-b from-teal-300 to-transparent"></div>
              )}

              <div className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-4 md:gap-8 items-center`}>
                {/* Image */}
                <div className="w-full md:w-1/2">
                  <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-lg border border-gray-100 group">
                    <div className="w-full h-[180px] md:h-[280px] overflow-hidden">
                      <img
                        src={step.image}
                        alt={`DMM FX口座開設 ステップ${step.number} ${step.title}`}
                        title={`DMM FX口座開設手順 ステップ${step.number}`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                    <div className="absolute top-2 md:top-4 left-2 md:left-4 bg-gradient-to-r from-teal-500 to-emerald-600 text-white px-2.5 md:px-4 py-1 md:py-2 rounded-lg text-xs md:text-sm font-bold shadow-lg">
                      STEP {step.number}
                    </div>
                    <div className="absolute top-2 md:top-4 right-2 md:right-4 bg-white/90 backdrop-blur-sm text-teal-700 px-2 md:px-3 py-1 md:py-1.5 rounded-full text-[10px] md:text-xs font-semibold shadow">
                      <i className="ri-time-line mr-1"></i>{step.time}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="w-full md:w-1/2">
                  <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-4">
                    <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full flex items-center justify-center text-white text-sm md:text-lg font-bold flex-shrink-0">
                      {step.number}
                    </div>
                    <h3 className="text-lg md:text-2xl font-bold text-gray-900">{step.title}</h3>
                  </div>

                  <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-5 leading-relaxed">{step.description}</p>

                  <div className="space-y-2 md:space-y-3 mb-3 md:mb-5">
                    {step.details.map((detail, idx) => (
                      <div key={idx} className="flex items-center gap-2 md:gap-3 bg-white rounded-lg px-3 md:px-4 py-2 md:py-2.5 border border-gray-100 shadow-sm">
                        <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center bg-teal-50 rounded-md flex-shrink-0">
                          <i className={`${detail.icon} text-teal-600 text-xs md:text-sm`}></i>
                        </div>
                        <span className="text-xs md:text-sm text-gray-700">{detail.text}</span>
                      </div>
                    ))}
                  </div>

                  <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 md:px-4 py-2 md:py-3 flex items-start gap-2">
                    <i className="ri-lightbulb-line text-amber-500 mt-0.5 flex-shrink-0 text-sm md:text-base"></i>
                    <p className="text-[10px] md:text-xs text-gray-700 leading-relaxed"><strong>ポイント：</strong>{step.tips}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
